import React, { memo, useState, useCallback, useEffect } from 'react'
import { Avatar, Box, Stack, Text, Wrap, WrapItem } from '@chakra-ui/react'
import { truncateWithEllipsis } from 'utils/string-formatters'
import { useDialerState } from './dialer.hooks'
//import _ from 'lodash'
import { useSelectedResidentContact } from '../contact-center.hooks'

type ContactListProps = {
  contacts?: any[]
  call: Function
}
type ContactItemProps = {
  contact: any
  call: Function
}

export const ContactItem: React.FC<ContactItemProps> = ({ contact, call }) => {
  const [isHovered, setIsHovered] = useState(false)

  const mouseEnter = useCallback(() => setIsHovered(true), [])
  const mouseLeave = useCallback(() => setIsHovered(false), [])

  //const { dialerState, setDialerState } = useDialerState()
  //const { setNumber } = useDialedNumber()

  const { selected, setSelected } = useSelectedResidentContact()

  /*const handleCall = () => {
    setNumber(contact.phoneNumber)
    setDialerState(prev => ({ ...prev, isCalling: true }))
    setSelected(contact)
    const d = _.clone(dialerState)
    d.number = contact.phoneNumber
    call(d)
  }*/

  return (
    <Box
      py="16px"
      px="30px"
      _hover={{
        bg: '#F2F7FE',
      }}
      bg={selected?.id === contact.id ? '#F2F7FE' : ''}
      width="100%"
      onMouseEnter={mouseEnter}
      onMouseLeave={mouseLeave}
      pos="relative"
      marginTop="0px !important"
      onClick={() => setSelected(contact)}
    >
      <Wrap cursor="pointer" onClick={() => {}} key={contact.id}>
        <WrapItem>
          <Avatar name={`${contact.firstName} ${contact.lastName}`} size="md" />
        </WrapItem>
        <WrapItem>
          <Stack>
            <Text fontSize="12px" color="gray.600" fontWeight="500" isTruncated={true}>
              {truncateWithEllipsis(`${contact.firstName} ${contact.lastName}`, 30)}
            </Text>
            <Text fontSize="12px" fontWeight="400" color="gray.700">
              {contact.phoneNumber}
            </Text>
          </Stack>
        </WrapItem>
      </Wrap>
      {isHovered && (
        <Box pos="absolute" display="inline-block" top="20%" left="78%">
          {/*<IconButton
            aria-label="call contact"
            variant="unstyled"
            icon={<PhoneIcon />}
            maxW="32px"
            onClick={handleCall}
      />*/ }
        </Box>
      )}
    </Box>
  )
}

export const ContactList: React.FC<ContactListProps> = memo(({ contacts, call }) => {
  const { dialerState } = useDialerState()

  const { selected, setSelected } = useSelectedResidentContact()

  useEffect(() => {
    if (selected) return
    contacts && setSelected(contacts[0])
  }, [])

  if (dialerState.isOpen || dialerState.isCalling) return null

  return (
    <Box overflowY="auto" maxH="650px" minH="650px" overflowX="hidden" pos="relative">
      <Stack spacing="25px">
        <Box p={5} pb={0}>
          <Text fontSize="16px" color="gray.700" fontWeight="500">
            Contacts
          </Text>
        </Box>
        {contacts?.map((contact, idx) => (
          <ContactItem contact={contact} call={call} key={idx} />
        ))}
      </Stack>
    </Box>
  )
})

export const PhoneIcon = () => {
  return (
    <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.1375 5.74375C4.0375 7.5125 5.4875 8.95625 7.25625 9.8625L8.63125 8.4875C8.8 8.31875 9.05 8.2625 9.26875 8.3375C9.96875 8.56875 10.725 8.69375 11.5 8.69375C11.8438 8.69375 12.125 8.975 12.125 9.31875V11.5C12.125 11.8438 11.8438 12.125 11.5 12.125C5.63125 12.125 0.875 7.36875 0.875 1.5C0.875 1.15625 1.15625 0.875 1.5 0.875H3.6875C4.03125 0.875 4.3125 1.15625 4.3125 1.5C4.3125 2.28125 4.4375 3.03125 4.66875 3.73125C4.7375 3.95 4.6875 4.19375 4.5125 4.36875L3.1375 5.74375Z"
        fill="white"
      />
    </svg>
  )
}
